/* The private storefront uses the existing basket's fixed-hamper contract.
   It writes local preview state only; Shopify checkout is configured elsewhere. */
(() => {
  const range = JSON.parse(document.getElementById('range-data')?.textContent || '[]');
  const bySlug = new Map(range.map(h => [h.h,h]));
  const base = '/';
  const hamperImage = h => window.ADM_ASSET
    ? window.ADM_ASSET('hampers/' + h + '/img/take-01-400.webp')
    : base + 'hampers/' + h + '/img/take-01-400.webp';
  // A hamper drawn by snippets/adm-hamper.liquid carries its own picture and variant (29 Oct 2026): the range's
  // hampers have theirs in the theme's assets and the shop map.
  const imageOf = h => h.thumb || hamperImage(h.h);
  const dialog = document.getElementById('basket-confirmation');
  const esc = s => String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = n => '£' + Number(n).toLocaleString('en-GB', {maximumFractionDigits:2});
  let adding = false, returnFocus, previousOverflow;
  function read() {
    return DeliBasketStore.read();
  }
  function save(basket,h,quantity) {
    DeliBasketStore.write(basket);
    const previous=DeliBasketStore.summary();
    const total=basket.gifts.every(g=>g.fixed)
      ? basket.gifts.reduce((n,g)=>n+g.price+(g.card?.price||0),0)
      : (previous?.total||0)+h.p*quantity;
    DeliBasketStore.setSummary({n:basket.gifts.length,total,name:basket.gifts[0]?.name||null});
    window.ADMChrome?.paintChip();
  }
  function close() { dialog?.close(); }
  if(dialog) {
    dialog.querySelectorAll('[data-close-basket]').forEach(b=>b.addEventListener('click',close));
    dialog.addEventListener('close',()=>{
      document.body.style.overflow=previousOverflow||'';
      adding=false;
      document.querySelectorAll('[data-add]').forEach(b=>b.disabled=false);
      returnFocus?.focus({preventScroll:true});
    });
    dialog.addEventListener('click',e=>{
      const r=dialog.getBoundingClientRect();
      if(e.target===dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))close();
    });
  }
  async function add(button) {
    if(adding || !dialog) return;
    const h=bySlug.get(button.dataset.add);
    if(!h) return;
    const personalised=button.hasAttribute('data-product-add');
    const field=document.getElementById('hamper-quantity');
    const quantity=personalised ? Number(field.value) : 1;
    const error=document.getElementById('purchase-error');
    if(error) error.hidden=true;
    // A hidden error must not stay attached: aria-describedby reads hidden text too.
    field?.removeAttribute('aria-invalid'); field?.removeAttribute('aria-describedby');
    if(!Number.isInteger(quantity)||quantity<1||quantity>99) {
      if(error) { error.textContent='Choose a quantity between 1 and 99.'; error.hidden=false; }
      field?.setAttribute('aria-invalid','true'); if(error) field?.setAttribute('aria-describedby','purchase-error');
      field?.focus(); return;
    }
    adding=true;
    const name=personalised ? document.getElementById('gift-recipient').value.trim() : '';
    const msg=personalised ? document.getElementById('gift-words').value.trim() : '';
    // A real greeting card chosen on the page (hamper-page.js, 27 Oct 2026) rides on the hamper whole, as the
    // builder's toBasket() hands it over: id, name, price, artwork and shelf. _cart.js adds it as its own £2.95 line
    // beside the hamper, sharing its _bundle_id, with _card on the hamper; Cards to print and the slip read those.
    const chosen=personalised && window.ADMCards ? ADMCards.byId(document.getElementById('gift-message')?.dataset.card) : null;
    const card=chosen ? {id:chosen.id,name:chosen.name,price:chosen.price,img:chosen.img,cat:chosen.cat} : null;
    const basket=read();
    for(let n=0;n<quantity;n++) basket.gifts.push({
      id:'fx-'+h.h+'-'+crypto.randomUUID(),fixed:true,handle:h.h,v:h.v?String(h.v):null,title:h.t,price:h.p,
      img:imageOf(h),count:h.count,hasAlcohol:!!h.alcohol,
      name,msg,occ:'',card:card?{...card}:null,cardPrice:card?card.price:0,day:null,svc:null,addr:null
    });
    try { save(basket,h,quantity); }
    catch(e) {
      adding=false;
      if(error) {error.textContent=e.message;error.hidden=false;}
      else {const note=document.getElementById('purchase-toast');note.textContent=e.message;note.hidden=false;}
      return;
    }
    returnFocus=button;
    previousOverflow=document.body.style.overflow;
    // "Quantity 1 · 7 selections each" read as a stock sheet; say it the way
    // a person would, and only mention hampers when there is more than one.
    // Two facts are a .dotted row (purchase.css): the dot between them is drawn,
    // so when the second wraps under the first no dot is left hanging.
    const what=quantity===1
      ? '<p>'+h.count+' selections</p>'
      : '<p class="dotted"><span>'+quantity+' hampers</span> <span>'+h.count+' selections in each</span></p>';
    document.getElementById('basket-added-item').innerHTML='<img src="'+imageOf(h)+'" width="400" height="400" alt="'+esc(h.t)+'"><div><h3>'+esc(h.t)+'</h3>'+what+(name?'<p>For '+esc(name)+'</p>':'')+(card?'<p class="added-message">With a “'+esc(card.name)+'” card, '+money(card.price)+(quantity>1?' each':'')+'</p>':msg?'<p class="added-message">Gift message included</p>':'')+'<strong>'+money((h.p+(card?card.price:0))*quantity)+'</strong></div>';
    document.getElementById('basket-confirmation-count').textContent=basket.gifts.length+(basket.gifts.length===1?' hamper in your basket':' hampers in your basket');
    // The next step is the basket's own next step, never a fixed line: a card
    // message is offered, not demanded (review item 19), and more than one
    // hamper is asked where each is going before any day (item 25).
    const next=dialog.querySelector('.basket-next-step');
    if(next) next.textContent=basket.gifts.length>1
      ? 'Next, in the basket: say where each hamper is going, then choose the day.'
      : msg ? 'Next, in the basket: choose the day it arrives.'
            : 'Next, in the basket: choose the day it arrives, and add a card message if you would like one.';
    dialog.showModal(); document.body.style.overflow='hidden';
    dialog.querySelector('[data-close-basket]').focus();
    document.querySelectorAll('[data-add]').forEach(b=>b.disabled=true);
  }
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-add]');
    if(button) {e.preventDefault();add(button);}
  });
  document.querySelectorAll('[data-add]').forEach(b=>b.disabled=false);
  document.querySelectorAll('[data-quantity-step]').forEach(b=>b.addEventListener('click',()=>{
    const input=document.getElementById('hamper-quantity');
    input.value=Math.min(99,Math.max(1,(Number(input.value)||1)+Number(b.dataset.quantityStep)));
  }));
  const words=document.getElementById('gift-words');
  words?.addEventListener('input',()=>document.getElementById('gift-word-count').textContent=words.value.length+' / 420');
  if(dialog) {
    const toast=document.createElement('p');toast.id='purchase-toast';toast.className='draft-toast';toast.setAttribute('role','alert');toast.hidden=true;document.body.append(toast);
  }
})();
